<div class="card" [ngStyle]="{'border-color': borderColor, 'padding': '10px'}">
  <div class="d-flex align-items-center">
    <span class="material-symbols-outlined me-3 dash-icon d-flex align-items-center justify-content-center"
          [ngStyle]="{'background-color': iconBg, 'color': iconColor}">
      {{ icon }}
    </span>
    <div class="d-flex flex-column justify-content-center">
      <div>{{ title }}</div>
      <div class="fw-bold fs-5">{{ value }}</div>
      <div class="text-muted">{{ subtitle }}</div>
    </div>
  </div>
</div>
